import React, { useRef, useCallback } from "react";
import styled from "styled-components";
import { Close } from "@mui/icons-material";
import { Button } from "antd";
import Loading from "components/Loading";
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import { 
  list, 
  formatBlock, 
  paragraphStyle,
  textStyle 
} from "suneditor/src/plugins";

const NoteEditor = ({
  data,
  open,
  close,
  onChange,
  index,
  saveTextHandler,
  notesLoading
}) => {
  const editorRef = useRef();

  const getSunEditorInstance = (sunEditor) => {
    editorRef.current = sunEditor;
  };

  const handleEditorChange = useCallback((content) => {
    if (onChange) {
      onChange(content);
    }
  }, [onChange]);

  return (
    <>
      {open ? (
        <NoteEditorContainer>
          <div className="flex justify-between w-full">
            <PageNumberContainer>
              Page {index + 1 || 0}
              <AddPageNumber> {"-"} Add page title</AddPageNumber>
            </PageNumberContainer>
            <div className="flex items-center gap-10px">
              <Button onClick={saveTextHandler}>{notesLoading ? <Loading size={18} /> : 'Save'}</Button>
              <IconWrapper onClick={() => close(false)}>
                <Close />
              </IconWrapper>
            </div>
          </div>

          <EditorContainer>
            <SunEditor
              key={`editor-${index}-${data?.id || 'new'}`}
              getSunEditorInstance={getSunEditorInstance}
              setAllPlugins={false}
              autoFocus={false}
            placeholder="Enter Page title"
              setOptions={{
                height: "800px",
                buttonList: [["list"]],
                plugins: [list, formatBlock, paragraphStyle, textStyle],
              }}
              onChange={handleEditorChange}
              defaultValue={data?.notes || ""}
            />
          </EditorContainer>
        </NoteEditorContainer>
      ) : null}
    </>
  );
};

export default NoteEditor;

const NoteEditorContainer = styled.div`
  position: fixed;
  inset: 0;
  width: 100%;
  max-width: 20%;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 14px;
  margin: 12px;
  padding: 10px;
  z-index: 1000;
  min-width: 300px;
`;

const IconWrapper = styled.div`
  cursor: pointer;
  color: #000;
`;

const AddPageNumber = styled.span`
  font-size: 14px;
  color: grey;
  font-weight: 700;
`;

const PageNumberContainer = styled.span`
  font-size: 14px;
  color: black;
  font-weight: 500;
`;

const EditorContainer = styled.div`
  margin-top: 10px;
  width: 100%;
`;
